<div class="main-card mb-3 card custom-card">
    <div class="card-body">
        <div class="current-plan">
            <h2>Current Plan</h2>
            <div class="price">
                <h3>₹{{q1_price}} </h3><span>{{q1_plan_name}}</span>
            </div>

            <div class="plan-details">
                <div class="plan-details-list">
                    <p><strong>Validity</strong></p>
                    <span>30 Days</span>
                </div>
                <div class="plan-details-list">
                    <p><strong>Data</strong></p>
                    <span>Unlimited</span>
                </div>
                <div class="plan-details-list">
                    <p><strong>Upload Speed</strong></p>
                    <span>{{q1_up_kbps_text}} Mbps</span>
                </div>
                <div class="plan-details-list">
                    <p><strong>Download Speed</strong></p>
                    <span>{{q1_dn_kbps_text}} Mbps</span>
                </div>
            </div>
            <div class="buy-btn" [class.disabled]="!isPayBillEnabled()"
                [style.pointerEvents]="!isPayBillEnabled() ? 'none' : 'auto'"
                (click)="invoicePayment(q1_plan_name,q1_price)">
                <div [attr.data-tooltip]="'Price: ₹' + q1_price"
                    class="button current-plan-button">
                    <div class="button-wrapper">
                        <div class="text">Pay Now</div>
                        <span class="icon">
                            <svg viewBox="0 0 16 16" class="bi bi-cart2"
                                fill="currentColor" height="16" width="16"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M0 2.5A.5.5 0 0 1 .5 2H2a.5.5 0 0 1 .485.379L2.89 4H14.5a.5.5 0 0 1 .485.621l-1.5 6A.5.5 0 0 1 13 11H4a.5.5 0 0 1-.485-.379L1.61 3H.5a.5.5 0 0 1-.5-.5zM3.14 5l1.25 5h8.22l1.25-5H3.14zM5 13a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0zm9-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0z">
                                </path>
                            </svg>
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <div class="popular-plans">
            <h3>Popular Plans</h3>

            <ngb-accordion [closeOthers]="true" activeIds="static-0">
                <ngb-panel *ngFor="let groupId of refGroupIds; let i = index"
                    [id]="'static-' + i">
                    <ng-template ngbPanelTitle>
                        <div
                            class="custom-header w-100 d-flex justify-content-between align-items-center">
                            <span class="header-text">
                                {{ groupId === 'Default' ? 'DEFAULT' :
                                groupId.toUpperCase() }}
                            </span>
                        </div>
                    </ng-template>
                    <ng-template ngbPanelContent>
                        <div class="panel-wrapper">
                            <div class="row">
                                <div class="col-12 col-lg-3"
                                    *ngFor="let item of groupedPlans[groupId]">
                                    <div class="plan-card">
                                        <div class="selling-plan-card">
                                            ₹{{ item.plan_price }}
                                            <i *ngIf="item.plan_price != 0"
                                                class="taxes">+Taxes</i>

                                            <span
                                                *ngIf="item.plan_price == q1_price"
                                                class="active-plan-badge"
                                                [ngClass]="{
       'active-badge': account_state === 'Active',
       'expired-badge': account_state === 'Expired'
     }">{{ account_state }}
                                            </span>

                                        </div>
                                        <p class="data-limt">{{ item.data_limit
                                            ?
                                            item.data_limit + ' GB' :
                                            'Unlimited'
                                            }}</p>
                                        <h4>{{ item.rule_name }}</h4>

                                        <div class="plan-details">
                                            <div class="plan-details-list">
                                                <p><strong>Validity</strong></p>
                                                <span>{{ item.time_limit ?
                                                    item.time_limit + ' Days' :
                                                    '30 Days' }}</span>
                                            </div>
                                        </div>

                                        <div class="buy-btn"
                                            [class.disabled]="isButtonDisabled(item.plan_price)"
                                            [style.pointerEvents]="isButtonDisabled(item.plan_price) ? 'none' : 'auto'"
                                            (click)="!isButtonDisabled(item.plan_price) && validateAndPay(item.rule_name, item.plan_price)">

                                            <div class="button"
                                                [attr.data-tooltip]="'Price: ₹' + item.plan_price">
                                                <div class="button-wrapper">
                                                    <div class="text">GET
                                                        &#64;₹{{
                                                        item.plan_price
                                                        }}/MONTH</div>
                                                    <span class="icon">
                                                        <svg
                                                            viewBox="0 0 16 16"
                                                            class="bi bi-cart2"
                                                            fill="currentColor"
                                                            height="16"
                                                            width="16"
                                                            xmlns="http://www.w3.org/2000/svg">
                                                            <path
                                                                d="M0 2.5A.5.5 0 0 1 .5 2H2a.5.5 0 0 1 .485.379L2.89 4H14.5a.5.5 0 0 1 .485.621l-1.5 6A.5.5 0 0 1 13 11H4a.5.5 0 0 1-.485-.379L1.61 3H.5a.5.5 0 0 1-.5-.5zM3.14 5l1.25 5h8.22l1.25-5H3.14zM5 13a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0zm9-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0z">
                                                            </path>
                                                        </svg>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="go-corner"
                                            (click)="openModal(item)">
                                            <div class="go-arrow">View
                                                →</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </ngb-panel>
            </ngb-accordion>

            <!-- <div class="row">

                <div class="col-12 col-lg-3"
                    *ngFor="let item of plan_name_list">

                    <div class="plan-card">
                        <div class="selling-plan-card">₹{{ item.plan_price }} <i
                                *ngIf="item.plan_price != 0" class="taxes">
                                +Taxes</i> <span class="bestseller"
                                *ngIf="item.plan_price == 699"> ⭐ Best
                                Seller</span></div>
                        <p class="data-limt">{{ item.data_limit &&
                            item.data_limit !== ''
                            ? item.data_limit + ' GB' : 'Unlimited' }}</p>
                        <h4>{{ item.rule_name }}</h4>

                        <div class="plan-details">
                            <div class="plan-details-list">
                                <p><strong>Validity</strong></p>
                                <span>
                                    {{ item.time_limit && item.time_limit !== ''
                                    ? item.time_limit + ' Days' : '30 Days' }}
                                </span>
                            </div>

                        </div>

                        <div class="buy-btn"
                            (click)="invoicePayment(item.rule_name,item.plan_price)">
                            <div
                                [attr.data-tooltip]="'Price: ₹' + item.plan_price"
                                class="button">
                                <div class="button-wrapper">
                                    <div class="text">GET &#64;₹{{
                                        item.plan_price }}/MONTH</div>
                                    <span class="icon">
                                        <svg viewBox="0 0 16 16"
                                            class="bi bi-cart2"
                                            fill="currentColor" height="16"
                                            width="16"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M0 2.5A.5.5 0 0 1 .5 2H2a.5.5 0 0 1 .485.379L2.89 4H14.5a.5.5 0 0 1 .485.621l-1.5 6A.5.5 0 0 1 13 11H4a.5.5 0 0 1-.485-.379L1.61 3H.5a.5.5 0 0 1-.5-.5zM3.14 5l1.25 5h8.22l1.25-5H3.14zM5 13a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0zm9-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0z">
                                            </path>
                                        </svg>
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div class="go-corner" (click)="openModal(item)">
                            <div class="go-arrow">View →</div>
                        </div>
                    </div>
                </div>
            </div> -->

        </div>
    </div>
</div>
<!-- Plan Modal -->
<div class="plan-modal" *ngIf="showModal">
    <div class="modal-box">
        <button class="close-btn" (click)="closeModal()">✖</button>

        <h2>Plan Summary</h2>
        <p class="modal-desc">Unlock blazing speed with our premium
            broadband
            plan!</p>

        <div class="modal-info">
            <div class="info-row">
                <strong>Plan Name:</strong>
                <span>{{plan_name}}</span>
            </div>
            <div class="info-row">
                <strong>Price:</strong>
                <span>₹{{price}}</span>
            </div>
            <div class="info-row">
                <strong>Uploading Speed:</strong>
                <span>{{max_upload}} Mbps</span>
            </div>
            <div class="info-row">
                <strong>Downloading Speed:</strong>
                <span>{{max_download}} Mbps</span>
            </div>
            <div class="info-row">
                <strong>Validity:</strong>
                <span>{{max_time}} Days</span>
            </div>
        </div>

        <div class="modal-actions">
            <!-- <button class="btn-primary"
                (click)="validateAndPay(plan_name,price)">Activate
                Now</button> -->
            <button class="btn-secondary"
                (click)="closeModal()">Close</button>
        </div>
    </div>
</div>
<!-- Current Plan Modal -->
<div class="plan-modal" *ngIf="showModalCurrentPlan">
    <div class="modal-box">
        <button class="close-btn"
            (click)="closeCurrentPlanModal()">✖</button>

        <h2>Plan Summary</h2>
        <p class="modal-desc">Unlock blazing speed with our premium
            broadband
            plan!</p>

        <div class="modal-info">
            <div class="info-row">
                <strong>Plan Name:</strong>
                <span>{{plan_name}}</span>
            </div>
            <div class="info-row">
                <strong>Price:</strong>
                <span>₹{{price}}</span>
            </div>
            <div class="info-row">
                <strong>Uploading Speed:</strong>
                <span>{{max_upload}} Mbps</span>
            </div>
            <div class="info-row">
                <strong>Downloading Speed:</strong>
                <span>{{max_download}} Mbps</span>
            </div>
            <div class="info-row">
                <strong>Validity:</strong>
                <span>{{max_time}} Days</span>
            </div>
        </div>

        <div class="modal-actions">
            <button class="btn-primary" (click)="confirmPurchase()">Activate
                Now</button>
            <button class="btn-secondary"
                (click)="closeModal()">Close</button>
        </div>
    </div>
</div>

<!-- Plan Modal -->
<div class="plan-modal" *ngIf="showModalUpgrade">
    <div class="modal-box">
        <button class="close-btn" (click)="closeModal()">✖</button>

        <h2>Plan Summary</h2>
        <!-- Info for existing plan -->
        <div class="alert-box" *ngIf="account_state == 'Active'">
            <p><strong>Note:</strong> You already have an active plan. It will
                expire on <strong>{{expire_time}}</strong>.</p>
            <p>If you upgrade now, the new plan will be <strong>queued</strong>
                and activated only after the current one ends.</p>

        </div>
        <p class="modal-desc">Unlock blazing speed with our premium
            broadband plan!</p>
        <!-- New Plan Info -->
        <div class="modal-info">
            <div class="info-row">
                <strong>Plan Name:</strong>
                <span>{{planName}}</span>
            </div>
            <div class="info-row">
                <strong>Price:</strong>
                <span>₹{{planPrice}}</span>
            </div>
            <div class="info-row">
                <strong>Uploading Speed:</strong>
                <span>{{uploadMbps}} Mbps</span>
            </div>
            <div class="info-row">
                <strong>Downloading Speed:</strong>
                <span>{{downloadMbps}} Mbps</span>
            </div>
            <div class="info-row">
                <strong>Validity:</strong>
                <span>{{validity}} Days</span>
            </div>
        </div>

        <div class="modal-actions">
            <button class="btn-primary"
                (click)="invoicePayment(planName, planPrice)">Activate
                Now</button>
            <button class="btn-secondary" (click)="closeModal()">Close</button>
        </div>
    </div>
</div>